import { render, staticRenderFns } from "./friend-follow.vue?vue&type=template&id=3a8c4eab&scoped=true"
import script from "./friend-follow.vue?vue&type=script&lang=js"
export * from "./friend-follow.vue?vue&type=script&lang=js"
import style0 from "./friend-follow.vue?vue&type=style&index=0&id=3a8c4eab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8c4eab",
  null
  
)

export default component.exports